import { useState, useEffect, useContext, useCallback } from "react";
import Logo from "./logo/Logo";
import Favicon from "../../../components/favicon/Favicon";
import AfterUserLogin from "./userlogin/AfterUserLogin";
import { useNavigate } from "react-router-dom";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
} from "../../../helpers/global_helper";
import UserLogin from "./userlogin/UserLogin";
import { useSelector } from "react-redux";
import Popup from "../../../components/popup/Popup";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import HomeScreenPopup from "../../../components/popup/popup-components/HomeScreenPopup";
import NavCarousel from "../navbar/NavCarousel";
import Navbar from "../navbar/Navbar";
import { useDispatch } from "react-redux";
import {
  fetchDepositPending,
  fetchOtherMediaInfo,
  fetchSubMenu,
  getActivePromoEvent,
} from "../../../store/actions";
import { ThemeModeContext } from "../../../components/ThemeMode/Context";
import ErrorBoundary from "../../../helpers/ExceptionHandler/componentException";

const MainHeader = (props) => {
  let loggedIn = window.localStorage.getItem("user_token");
  const { componentSetting, otherMedia } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
    otherMedia: state.othermediaInformationListR.data,
  }));

  const { userProfile } = useSelector((state) => ({
    userProfile: state.playerProfileR?.data ?? {},
  }));
  const [popup, setPopup] = useState(false);
  const [popupUnreadMessage, setPopupUnreadMessage] = useState(undefined);
  const [popupNotificationClosed, setPopupNotificationClosed] = useState(false);
  const [popupMessageId, setPopupMessageId] = useState(null);
  const [destopBeforeLogin, setDestopBeforeLogin] = useState(false);
  const [destopAfterLogin, setDestopAfterLogin] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPath = window.location.pathname;
  const { themeMode } = useContext(ThemeModeContext);

  const [isNotification, setNotification] = useState(false);
  const [notificationCount, setNoticationCount] = useState(0);
  const [newMemoMessage, setNewMemoMessage] = useState(false);
  const [dismissedMessageId, setDismissedMessageId] = useState(null);



  const handlePopupCheckbox = (isPopupEnabled) => {
    const currentDate = new Date().toISOString();
    const key =
      loggedIn == false || loggedIn == null
        ? "pop_up_before_login"
        : "pop_up_after_login";

    if (isPopupEnabled) {
      localStorage.setItem(key, currentDate);
    } else {
      localStorage.removeItem(key);
    }
  };

  const handlePopup = () => {
    setPopup(false);
    setNewMemoMessage(false);
    setDestopBeforeLogin(false);
    setDestopAfterLogin(false);
    setNotification(false);
  };
  let urlData = window.location.pathname.split("/").pop();

  //image hide
  useEffect(() => {
    const checkPopupStatus = (key, setFunction) => {
      const storedDate = localStorage.getItem(key);
      if (storedDate == null) {
        setFunction(true);
      } else {
        const currentDate = new Date();
        const targetDate = new Date(storedDate);
        const timeDifferenceInHours =
          (currentDate - targetDate) / (1000 * 60 * 60);
        //check time diff is more than 24 hrs or not
        setFunction(timeDifferenceInHours > 24);
      }
    };

    // Check before login popup status (24-hour threshold)
    if (loggedIn == false || loggedIn == null) {
      checkPopupStatus("pop_up_before_login", setDestopBeforeLogin);
    } else {
      // Check after login popup status (24-hour threshold)
      checkPopupStatus("pop_up_after_login", setDestopAfterLogin);
    }
  }, []);

  useEffect(() => {
    if (urlData == "") {
      setPopup(true);
    }
  }, [urlData]);

  useEffect(() => {
    if (loggedIn && popupNotificationClosed === false) {
      unreadPopUpMessages();
      getNotificationCount();
      const interval = setInterval(() => {
        if (!popupNotificationClosed) unreadPopUpMessages();

      }, 6000);
      return () => clearInterval(interval);
    }
  }, [loggedIn, popupNotificationClosed]);



  const unreadPopUpMessages = () => {

    if (popupNotificationClosed) return;

    makeAjax(url.MEMO_API.getUnreadPopUpMessage, [], url.MEMO_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        if (response?.data?.direction == "AP") {
          return;
        }
        setPopupUnreadMessage(response?.data);
        if (response.data != null) {
          const messageId = response?.data?._id;
          if (messageId === dismissedMessageId) return;

          if (response?.data?.notification_type == "deposit" && localStorage.getItem("hkb_provider_deposit")) {
            localStorage.removeItem("hkb_provider_deposit");
            setPopupMessageId(messageId);
            messageRead(messageId);
            return;
          }
          if (messageId && response?.data?.popup_message == "memo") {
            setNewMemoMessage(true);
          } else {
            setPopupNotificationClosed(true);
          }
          setPopupMessageId(response?.data?._id);
        }
      }
    );
  };

  const unreadPopUpMemoMessages = () => {

    makeAjax(url.MEMO_API.getUnreadPopUpMessage, [], url.MEMO_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }

        setPopupUnreadMessage(response?.data);
        if (response.data != null) {
          const messageId = response?.data?._id;
          if (messageId === dismissedMessageId) return;

          if (response?.data?.notification_type == "deposit" && localStorage.getItem("hkb_provider_deposit")) {
            localStorage.removeItem("hkb_provider_deposit");
            setPopupMessageId(messageId);
            messageRead(messageId);
            return;
          }
          if (messageId && response?.data?.notification_type == "memo" && !newMemoMessage) {
            setNewMemoMessage(true);
          }
          setPopupMessageId(response?.data?._id);
        }
      }
    );
  };

  useEffect(() => {
    if (!loggedIn) return;

    unreadPopUpMemoMessages();

    const interval = setInterval(() => {
      unreadPopUpMemoMessages();
    }, 6000);

    return () => clearInterval(interval);

  }, [loggedIn, unreadPopUpMemoMessages]);

  const handleNotificationPopup = () => {
    messageRead();
    setPopupNotificationClosed(false);
    setPopupMessageId(null);
    setNewMemoMessage(false);
    setNotification(false);
    setPopupUnreadMessage(undefined);
    setDismissedMessageId(popupMessageId)
  };

  const messageRead = (messageId = null) => {
    if (messageRead != null) {

      const payload = { _id: popupMessageId };
      if (messageId) {
        payload['_id'] = messageId;
      }

      makeAjax(
        url.MEMO_API.updatePopupMessageStatus,
        payload,
        url.MEMO_MS_EXT
      ).then((response) => {
        if (response.status !== respStatus.SUCCESS) {
          showMessage(response);
          return;
        }

        setPopupNotificationClosed(true);
        dispatch(fetchDepositPending());
        dispatch(getActivePromoEvent());

        if (messageId) {
          window.close();
        }

        if (currentPath === "/transaction-queue") {
          navigate("/withdraw");
        }
      });
    }
  };

  //admic compose pop memo
  const getNotificationCount = () => {
    makeAjax(
      url.MEMO_API.getPlayerUnreadMessageCount,
      [],
      url.MEMO_MS_EXT
    ).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setNoticationCount(response.data);
    });
  };



  return (
    <div
      className={`header-components ${componentSetting?.["top-nav-login-box"]?.["default-value"]} `}
    >
      {typeof componentSetting?.["top-nav-logo"] != "undefined" &&
        componentSetting?.["top-nav-logo"]?.["default-value"] && <ErrorBoundary><Logo /></ErrorBoundary>}
      <Favicon />
      {componentSetting?.["nav-bar"]?.["default-value"] == "horizonatal" &&
        componentSetting?.custom_loading?.options?.header_handle && <ErrorBoundary><Navbar /></ErrorBoundary>}
      {componentSetting?.["nav-bar"]?.["default-value"] == "nav-carozal" && (
        <ErrorBoundary><NavCarousel /></ErrorBoundary>
      )}
      {loggedIn ? (
        <>
          {componentSetting != null &&
            typeof componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] != "undefined" &&
            componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] &&
            popupUnreadMessage && popupUnreadMessage != undefined &&
            popupUnreadMessage != "undefined" &&
            popupUnreadMessage != null &&
            popupUnreadMessage != 'null' &&
            popupNotificationClosed && (
              <ErrorBoundary>
                <HomeScreenPopup
                  handlePopup={handleNotificationPopup}
                  popupNotificationClosed={popupNotificationClosed}
                  data={popupUnreadMessage}
                  setNotification={setNotification}
                  messageRead={messageRead}
                />
              </ErrorBoundary>
            )}
        </>
      ) : null}
      {loggedIn ? (
        <>
          {componentSetting != null &&
            typeof componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] != "undefined" &&
            componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] && <AfterUserLogin />}
        </>
      ) : (
        <>
          {componentSetting != null &&
            typeof componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] != "undefined" &&
            componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] && !loggedIn && <UserLogin />}
        </>
      )}

      {popup &&
        otherMedia?.["pop_up_after_login"]?.[0]?.[
        "image_status"
        ] &&
        loggedIn != null &&
        loggedIn != "" &&
        destopAfterLogin && (
          <div className="homepage-popup">
            {" "}
            <Popup
              handlePoup={handlePopup}
              handlePopupCheckbox={handlePopupCheckbox}
              afterLogin
            />
          </div>
        )}

      {popup &&
        otherMedia?.["pop_up_before_login"]?.[0]?.[
        "image_status"
        ] &&
        loggedIn == null &&
        destopBeforeLogin && (
          <div className="homepage-popup">
            <Popup
              handlePoup={handlePopup}
              handlePopupCheckbox={handlePopupCheckbox}
              beforeLogin
            />
          </div>
        )}

      {isNotification && (
        <Popup
          handlePoup={handlePopup}
          length={notificationCount}
          getNotificationCount={getNotificationCount}
          readNotification
        />
      )}

      {loggedIn ? (
        <>
          {componentSetting != null &&
            typeof componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] != "undefined" &&
            componentSetting?.["device-login-info"]?.["options"]?.[
            "user-login"
            ] &&
            popupUnreadMessage && popupUnreadMessage && popupUnreadMessage != undefined &&
            popupUnreadMessage != "undefined" &&
            popupUnreadMessage != null &&
            popupUnreadMessage != 'null' &&
            newMemoMessage && (
              <Popup
                handleMemoPopup={handleNotificationPopup}
                newMemoMessage
                length={notificationCount}
                setNotification={setNotification}
                getNotificationCount={getNotificationCount}
              />
            )}
        </>
      ) : null}
    </div>
  );
};
MainHeader.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(MainHeader);
